var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookmarkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 42,
    viewBox: "0 0 32 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 0H30C30.5304 0 31.0391 0.210714 31.4142 0.585786C31.7893 0.960859 32 1.46957 32 2V40.286C32.0002 40.4648 31.9525 40.6404 31.8618 40.7945C31.7711 40.9486 31.6407 41.0756 31.4843 41.1622C31.3278 41.2488 31.151 41.2918 30.9723 41.2869C30.7936 41.2819 30.6194 41.2291 30.468 41.134L16 32.06L1.532 41.132C1.38074 41.227 1.20677 41.2798 1.0282 41.2849C0.849633 41.2899 0.672972 41.247 0.51659 41.1606C0.360208 41.0743 0.229814 40.9476 0.138966 40.7938C0.0481176 40.64 0.000132942 40.4646 0 40.286V2C0 1.46957 0.210714 0.960859 0.585787 0.585786C0.96086 0.210714 1.46957 0 2 0ZM28 4H4V34.864L16 27.342L28 34.864V4Z",
    fill: "#20E083"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkIcon);
export default __webpack_public_path__ + "static/media/bookmark-icon.18bd273319ad9416a5d379cd190d9e99.svg";
export { ForwardRef as ReactComponent };